import { render, staticRenderFns } from "./ArchiveDepartmentDialog.vue?vue&type=template&id=39fcc638"
import script from "./ArchiveDepartmentDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchiveDepartmentDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports